export const constants = {
  id: 'home',
  name: 'Home',
  // thumb: process.env.PUBLIC_URL + '/asset/blue-cube.png',
  thumb:
    'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/asset/blue-cube.png?raw=true',
};

export const tags = [
  {
    id: 'enterprise',
    en: 'Enterprise BlockChain Platform Solution',
    ko: '엔터프라이즈 블록체인 플랫폼 솔루션',
  },
  {
    id: 'hyperledger',
    en: 'Based on Hyperledger',
    ko: '하이퍼레저 기반',
  },
];
